import React, { FunctionComponent } from 'react';
import { BasicCheckbox } from '../../basic-inputs';
import FormField from '../FormField';
import { FormFieldProps } from '../types';
interface CheckboxProps {
  id: string;
  label?: string;
  disabled?: boolean;
  type?: CheckboxType;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
}

type CheckboxType = 'checkbox' | 'toggle';

type Props = FormFieldProps & CheckboxProps;

export type CheckboxFieldProps =
  | { name: string } & CheckboxProps
  | { name: string } & CheckboxProps & FormFieldProps;

const Checkbox: FunctionComponent<Props> = props => {
  const {
    id,
    type = 'checkbox',
    disabled,
    label,
    onChange,
    onBlur,
    form,
    field
  } = props;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    form.handleChange(e);
    if (onChange) {
      onChange(e);
    }
  };

  const handleBlur = (e: any) => {
    form.handleBlur(e);
    if (onBlur) {
      onBlur(e);
    }
  };

  return (
    <BasicCheckbox
      id={id}
      type={type}
      disabled={disabled}
      checked={field.value}
      label={label}
      name={field.name}
      value={field.value}
      onBlur={handleBlur}
      onChange={handleChange}
    />
  );
};

const CheckboxField: React.FC<CheckboxFieldProps> = props => (
  <FormField component={Checkbox} {...props} />
);

export default CheckboxField;
